<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <MensagemAlerta class="row-space" v-if="msg" :mensagem="msg" />

    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ objEdicao.cdproduto }}</div>
            </div>
            <div class="form-item">
                <label class="label-caption" for="nmproduto">Nome</label>
                <input type="text" v-model="objEdicao.nmproduto" id="nmproduto" maxlength="80" v-uppercase />
            </div>
            <div class="form-item-char20">
                <label class="label-caption" for="unidade">Unidade</label>
                <input type="text" v-model="objEdicao.unidade" id="unidade" maxlength="6" v-uppercase />
            </div>
        </div>

        <div v-if="objEdicao.id==0" class="row row-space">            
            <AtividadeSelect class="form-item" v-model:atividadeSelecionada="objEdicao.idatividade" />
        </div>

        <div class="row-end">
            <label for="ativo">Ativo</label>
            <input type="checkbox" class="input-checkbox" id="ativo" v-model="ckAtivo" />
        </div>

        <div class="row-end">
            <label for="ckMp">Ítem de Matéria Prima</label>
            <input type="checkbox" class="input-checkbox" id="ckMp" v-model="ckMp" />
        </div>

        <div class="row-end row-space">
            <label for="ckProducao">Ítem de Produção</label>
            <input type="checkbox" class="input-checkbox" id="ckProducao" v-model="ckProducao" />
        </div>

        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>        
    </div>
</template>
  
<script setup>
import { criarProduto } from '@/models/produto';
import { onMounted, ref } from 'vue';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import AtividadeSelect from '@/components/selects/AtividadeSelect.vue';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({
    idAtividade: {type: Number, default: 0},
    idEdicao: {type: Number, default: 0}
});

const ckAtivo = ref(false);
const ckMp = ref(false);
const ckProducao = ref(false);
const isLoading = ref(false);
const msg = ref(null);
const objEdicao = ref(criarProduto());

const cancelForm = () => {emit('close');}

const lerDados = async() => {
    try{
        isLoading.value = true;
        msg.value       = null;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('produto', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msg.value = error}
        }else{
            objEdicao.value.idep        = globalStore.idep;
            objEdicao.value.idatividade = props.idAtividade;
            objEdicao.value.idlogin     = globalStore.idlogin;
        }
        objEdicao.value.idusuario       = globalStore.idusuario;
        ckAtivo.value                   = objEdicao.value.ativo === 'S';        
        ckMp.value                      = objEdicao.value.ckmp === 'S';        
        ckProducao.value                = objEdicao.value.ckproducao === 'S';        
    } catch (error) {msg.value = error;
    }finally{isLoading.value=false;}
};

const salvarDados = async() => {
    if (!objEdicao.value.nmproduto || objEdicao.value.nmproduto.trim() === '') {msg.value='Informe o nome do produto'; return;}
    try {
        isLoading.value             = true;
        msg.value                   = null;
        objEdicao.value.ativo       = ckAtivo.value ? 'S' : 'N';
        objEdicao.value.ckmp        = ckMp.value ? 'S' : 'N';
        objEdicao.value.ckproducao  = ckProducao.value ? 'S' : 'N';
        const response              = await genericPut('/cad/produto', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msg.value = response.erro;
        }
    } catch (error) {msg.value = error;
    } finally{isLoading.value=false;}
}

onMounted(lerDados);
</script>